// Android端末で表示の時のみクラス付与
$(function () {
    if(navigator.userAgent.indexOf('Android') > 0){
        $("html").addClass("android");
    }
});

// コレクションページ絞り込みカスタム
$(function(){
    $(".toggle_1_btn").on("click", function() {
        $(".toggle_2").slideUp();
        $(".toggle_2_btn").removeClass('open');
        $(".toggle_3").slideUp();
        $(".toggle_3_btn").removeClass('open');
        $(".toggle_1").slideToggle();
        $(this).toggleClass('open');
    });
    $(".toggle_2_btn").on("click", function() {
        $(".toggle_1").slideUp();
        $(".toggle_1_btn").removeClass('open');
        $(".toggle_3").slideUp();
        $(".toggle_3_btn").removeClass('open');
        $(".toggle_2").slideToggle();
        $(this).toggleClass('open');
    });
    $(".toggle_3_btn").on("click", function() {
        $(".toggle_1").slideUp();
        $(".toggle_1_btn").removeClass('open');
        $(".toggle_2").slideUp();
        $(".toggle_2_btn").removeClass('open');
        $(".toggle_3").slideToggle();
        $(this).toggleClass('open');
    });
});document.addEventListener('DOMContentLoaded', function() {
    function zeroPadSelectOptions(selectId) {
      var select = document.getElementById(selectId);
      for (var i = 0; i < select.options.length; i++) {
        var value = select.options[i].value;
        if (value.length === 1) {
          select.options[i].value = '0' + value;
        }
      }
    }
    zeroPadSelectOptions('birthday_m');
    zeroPadSelectOptions('birthday_d');
  });
// sakekasu-renewalページ アンカーリンク挙動調整
$(function () {
  const pageWidth = document.documentElement.scrollWidth;
  if (pageWidth <= 1100) {
    $(".renewal_menu a[href^='#']").on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(this.hash).offset().top - 100
      }, 300, function () {
      });
    });
  }
  else {
    $(".renewal_menu a[href^='#']").on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(this.hash).offset().top - 218
      }, 300, function () {
      });
    });
  };
});

// ドロワーカート内 注文メモのアコーディオン
function bindAccordionEvents() {
  $(document).on("click", ".cart-note-dialog_custom .accordion_header", function(event) {
    event.preventDefault();
    $(this).toggleClass("open");
    $(this).next(".accordion_inner").slideToggle();
  });
}
bindAccordionEvents();
const cartDrawer = document.querySelector("#CartDrawer");
if (cartDrawer) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        bindAccordionEvents();
      }
    });
  });
  observer.observe(cartDrawer, { childList: true, subtree: true });
}